import React from 'react'
import { connect } from 'react-redux';
import AiInsightsHeader from './AiInsightsHeader'
import AiInsightsContent from './AiInsightsContent';


const TabAiInsights = ({ aiInsightsCategories }) => (
  <div className="COLS aiInsightsWrap">
    <div className="CELL list-inner-container">
      <div className="list-view-area">
        {
          aiInsightsCategories?.length > 0 ?
            <div className="ai-insights-container">
              <AiInsightsHeader />
              <AiInsightsContent />
            </div> :
            <div className='ai-insights-unavailable'>No Reports Available</div>
        }
      </div>
    </div>
  </div>
);


const mapStateToProps = ({ AiInsightsReducer }) => {
  const { aiInsightsCategories } = AiInsightsReducer;

  return { aiInsightsCategories };
};


export default connect(mapStateToProps)(TabAiInsights);